import {gql} from '@apollo/client';

export const boardViewMutations = {
    CREATE_BOARD_VIEW: gql`
        mutation createBoardView($input: BoardViewCreateInput!) {
            createBoardView(input: $input) {
                id
                title
                description
                boardViewType
                itemView
                order
                itemDataPresentationSummary
                boardId
            }
        }
    `,
    UPDATE_BOARD_VIEW: gql`
        mutation updateBoardView($input: BoardViewUpdateInput!) {
            updateBoardView(input: $input) {
                id
                title
                description
                boardViewType
                itemView
                order
                itemDataPresentationSummary
                boardId
            }
        }
    `,
    REMOVE_BOARD_VIEWS_BY_IDS: gql`
        mutation removeBoardViewsByIds($ids: [UUID!]!) {
            removeBoardViewsByIds(ids: $ids) {
                statusCode
                message
                success
                data
            }
        }
    `,
};
